import React from "react";
import s from "./ScoresReport.module.scss";
import { Score } from "../../utils/types";

interface IReportRiskValue {
  score?: Score;
  first?: Score;
  last?: Score;
}

export const ReportRiskValue: React.FC<IReportRiskValue> = ({
  score,
  first,
  last,
}) => {
  if (!score?.score || !score?.severity) {
    return (
      <div className={s.widgetRisk}>
        <div className={s.widgetRiskLabel}>No enough data</div>
        <div className={s.widgetRiskTag}>Try a different address, please</div>
      </div>
    );
  }

  return (
    <div className={s.widgetRisk}>
      <p className={s.widgetRiskLabel}>Risk Range</p>
      <p className={s.widgetRiskValue}>{`${last?.score}-${first?.score}`}</p>
    </div>
  );
};
